import type { IconSvgObject } from './types';

const LanguageCircleIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 8.5H11.5M11.5 8.5H17M11.5 8.5V7M8.5 17C11 15 14 11 14.5 8.5M10 11C10.5 12.5 12.5 15 13.5 15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LanguageCircleIcon;
